/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import MaxLengthNumericEditor from '../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../SharedModules/GridTable/StyleConstant';

export const labelerTableHead = [
  {
    headerName: 'Dispute Specialist',
    field: 'specialist',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_250,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Rebate Program',
    field: 'programDisplay',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_250,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'To Be Assigned',
    field: 'unassigned',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'CheckPayeeCell',
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_170,
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Previously Assigned',
    field: 'assigned',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_200,
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
    },
    excelAlignment: 'right',
    dataAlignRight: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total',
    field: 'total',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    minWidth: Styles.Width_150,
    filter: 'agTextColumnFilter',
    cellStyle: {
      borderRightColor: Styles.BorderColor,
      textAlign: 'right',
    },
    excelAlignment: 'right',
    dataAlignRight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
